<!-- 조직관리 > 관리자관리 상세 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.companyName')}}</div>
          <div class="row">
            <div class="txt">{{`${clientName}(${companyName})`}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.id')}}<span class="imp">*</span></div>
          <div class="row">
            <c-btn01 :btn-text="t('message.add')" class="sm" @click="openPopup" v-if="!adminIdx"/>
            <div class="txt02">{{memberId}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.changeInfo')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="historyCnt" @click="onClickChangeDialog()"/>
          </div>
        </div>
      </div>
    </div>
    <div class="tit-group">
      <h3 class="tit">{{t('message.permissionManagement')}}</h3>
    </div>
    <div class="content-inner-box-wrap">
      <div class="content-inner-box">
        <div class="tit-group">
          <h4 class="tit">{{t('message.organizationManagement')}}</h4>
        </div>
        <div class="form-group col-ty">
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.companyManagement')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authCompany"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.memberManagement')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authMember"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.adminManagement')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authAdmin"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.systemNotification')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authBoard"/>
            </div>
          </div>
        </div>
      </div>
      <div class="content-inner-box">
        <div class="tit-group">
          <h4 class="tit">{{t('message.moduleManagement')}}</h4>
        </div>
        <div class="form-group col-ty">
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.bbsMonitoring')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authBbs"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.safetyLeadership')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authLeadership"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row">
            <div class="txt-tit">{{t('message.safetyLeadershipTotalScore')}}</div>
            <div class="row">
              <Select v-bind="select01" v-model="authLeadershipResult"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 v-bind="btnPageList" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <c-btn02 v-bind="btnPageDel" @click="dialogPageDelModel=true"/>
        <c-btn01 v-bind="btnPageModify" @click.stop.prevent="handleForm"/>
      </div>
    </div>
  </div>
  <!--변경정보-->
  <c-dialog v-model="dialogChangeNumModel"
            v-bind="dialogChangeNumBind"
            :dialogText="historyDialogText"
            @close="dialogChangeNumModel=false"
  />
  <DialogTargetAdd
    v-model="dialogAdmin"
    @close="dialogAdmin=false"
    @confirm="confirmAdmin"/>
  <!--삭제-->
  <c-dialog v-model="dialogPageDelModel"
            v-bind="dialogPageDelBind"
            @close="dialogPageDelModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import { ref } from 'vue'
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import LogService from "@/services/log.service";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
let changeLog = []

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const snackbar = ref(false)
const snackText = ref('')
const clientName = ref('')
const dialogChangeNumModel = ref(false)
const dialogPageDelModel = ref(false)
const adminIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const companyName = ref('')
const memberId = ref('')
const memberIdx = ref(null)
const authCompany = ref('0')
const authMember = ref('0')
const authAdmin = ref('0')
const authBoard = ref('0')
const authBbs = ref('0')
const authLeadership = ref('0')
const authLeadershipResult = ref('0')
const historyCnt = ref(0)
const historyDialogText = ref('')
const dialogAdmin = ref(false)

//ui
let dialogChangeNumBind = {
  dialogTit: t('message.changeInfoFormat'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogPageDelBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.confirmAdminDemotion'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const select01 = {
  items:
    [{name: t('message.none'), value: '0'}, {name: t('message.view'), value: '1'}, {name: t('message.edit'), value: '2'}]
}
const btnPageList = {
  btnText: t('message.list'),
}
const btnPageDel = {
  btnText: t('message.delete'),
}
const btnPageModify = {
  btnText: t('message.registerOrUpdate'),
}

//hook
onMounted(() => {
  clientName.value = localStorage.getItem('clientName')
  companyName.value = localStorage.getItem('companyName')
  if (adminIdx) {
    let params = {
      idx: adminIdx
    }

    MemberService.getCompanyAdmin(params).then(
      (response) => {
        //adminIdx.value = response.result.idx
        memberId.value = response.result.memberId
        authCompany.value = response.result.authCompany
        authMember.value = response.result.authMember
        authAdmin.value = response.result.authAdmin
        authBoard.value = response.result.authBoard
        authBbs.value = response.result.authBbs
        authLeadership.value = response.result.authLeadership
        authLeadershipResult.value = response.result.authLeadershipResult
        historyCnt.value = response.result.historyCnt
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
function handleForm(){
  if(import.meta.env.MODE == 'development') {
    utils.movePage('/organizationalManagement/3/list')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let params = {
      idx : adminIdx,
      companyIdx: localStorage.getItem('companyIdx'),
      memberIdx: memberIdx.value,
      authCompany : authCompany.value,
      authMember : authMember.value,
      authAdmin : authAdmin.value,
      authBoard : authBoard.value,
      authBbs : authBbs.value,
      authLeadership : authLeadership.value,
      authLeadershipResult : authLeadershipResult.value,
    }

    MemberService.insertCompanyAdmin(params).then(
      (response) => {
        if(response.success)
          utils.movePage('/organizationalManagement/3/list')
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

function openPopup(type){
  let companyIdx = localStorage.getItem('companyIdx')
  storeRef.popupIdx.value = companyIdx
  storeRef.popupType.value = type
  dialogAdmin.value = true
}

function onClickGoList(){
  utils.movePage('/organizationalManagement/3/list')
}

const onClickChangeDialog = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'admin',
    parentIdx: adminIdx
  }
  LogService.getLogList(params).then(
    (response:any) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach(function(row) {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeNumModel.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmAdmin=(item)=>{
  if(item.adminYn == 'Y'){
    snackText.value = t('message.accountAlreadyExists')
    snackbar.value = true
  }
  else {
    memberId.value = item.memberInfo
    memberIdx.value = item.idx
  }
  dialogAdmin.value=false
}

const confirmDelete=async()=>{
  try{
    let companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx:companyIdx,
      adminArr: [adminIdx],
    }
    const response = await MemberService.deleteCompanyAdmin(params)
    if(response.success)
      utils.movePage('/organizationalManagement/3/list')
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch (error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}
</script>

